/* Sable & Ochre - explicit region selection.
 *
 * WHY THIS EXISTS: the shop lists every animal twice, once as an EU edition and
 * once as a US edition, because each is fulfilled by a different printer. The
 * collection template already hid the other edition, but it decided from
 * localization.country.iso_code - the visitor's IP country - and the homepage
 * gallery did not filter at all, so the salon showed both editions of everything.
 * Customers now choose, and that choice is what filters the shop.
 *
 * HOW CARDS ARE IDENTIFIED: every product handle ends in "-eu" or "-us", and in
 * every section the <a> to the product IS the card (salon-field > a, mw-grid > a).
 * So no template needs a data attribute: the link's own href is the signal, and
 * hiding the link hides the card. Anything without a region suffix is left alone.
 */
(function () {
  'use strict';

  var KEY = 'hp-region';
  var root = document.documentElement;

  /* Shared with the gate: localStorage first, cookie behind it. Storage
     access throws outright in hardened contexts, and without the cookie the
     chosen region could not survive a single page navigation there. */
  var S = window.hpStore || {
    get: function (k) {
      try { var v = localStorage.getItem(k); if (v !== null) { return v; } } catch (e) {}
      var m = document.cookie.match('(^|;)\\s*' + k + '=([^;]*)');
      return m ? decodeURIComponent(m[2]) : null;
    },
    set: function (k, v) {
      try { localStorage.setItem(k, v); } catch (e) {}
      try { document.cookie = k + '=' + encodeURIComponent(v) + ';path=/;max-age=31536000;SameSite=Lax'; } catch (e) {}
    },
    clear: function (k) {
      try { localStorage.removeItem(k); } catch (e) {}
      try { document.cookie = k + '=;path=/;max-age=0;SameSite=Lax'; } catch (e) {}
    }
  };
  function stored() { return S.get(KEY); }
  function store(v) { S.set(KEY, v); }

  function regionOfHref(href) {
    if (!href || href.indexOf('/products/') === -1) return null;
    var path = href.split('?')[0].replace(/\/$/, '');
    if (/-eu$/i.test(path)) return 'eu';
    if (/-us$/i.test(path)) return 'us';
    return null;
  }

  /* Two surfaces behave differently, so one rule cannot be "hide the others".
   *
   *   - The collection grid renders BOTH editions of every animal. There, the
   *     right move is to hide the one that does not apply.
   *   - The salon renders only ONE edition per animal on purpose: the artwork is
   *     identical in both, so the wall shows each portrait once and links to the
   *     EU product. Hiding there emptied the entire gallery for a US visitor -
   *     0 products on the homepage, verified live.
   *
   * So links are grouped by animal (the handle minus its -eu/-us suffix). If the
   * chosen edition is present in the group, the others are hidden; if it is not,
   * the link is repointed at it. Every animal exists in both editions, so the
   * rewritten URL always resolves.
   */
  /* The header switch shows which edition is in force. Driven from
     apply() rather than from the click, so it is also correct on a cold
     load and after the chooser is used. */
  function syncSwitch(region) {
    var btns = document.querySelectorAll('[data-region-set]');
    for (var i = 0; i < btns.length; i++) {
      btns[i].setAttribute('aria-pressed',
        String(btns[i].getAttribute('data-region-set') === region));
    }
  }

  function apply(region) {
    if (!region) return;
    root.setAttribute('data-hp-region', region);
    syncSwitch(region);

    var links = document.querySelectorAll('a[href*="/products/"]');
    var groups = {};
    var i, a, r, href, base;

    for (i = 0; i < links.length; i++) {
      a = links[i];
      href = a.getAttribute('href');
      r = regionOfHref(href);
      if (!r) continue;                        /* not a regional product - never touch */
      base = href.split('?')[0].replace(/\/$/, '').replace(/-(eu|us)$/i, '');
      (groups[base] = groups[base] || []).push({ el: a, region: r, href: href });
    }

    var shown = 0, hidden = 0, rewritten = 0;
    for (base in groups) {
      if (!Object.prototype.hasOwnProperty.call(groups, base)) continue;
      var group = groups[base];
      var hasChosen = false;
      for (i = 0; i < group.length; i++) { if (group[i].region === region) { hasChosen = true; break; } }

      for (i = 0; i < group.length; i++) {
        var item = group[i];
        if (hasChosen) {
          if (item.region === region) { item.el.removeAttribute('data-hp-hidden'); shown++; }
          else { item.el.setAttribute('data-hp-hidden', ''); hidden++; }
        } else {
          /* only the other edition is on this page - point it at ours */
          item.el.setAttribute('href', item.href.replace(/-(eu|us)(\b|$)/i, '-' + region + '$2'));
          item.el.removeAttribute('data-hp-hidden');
          rewritten++;
        }
      }
    }
    root.setAttribute('data-hp-filtered', shown + ' shown, ' + hidden + ' hidden, ' + rewritten + ' repointed');
  }

  /* The chooser. Shown only when nothing is stored. The button matching the
     visitor's detected country is marked as the suggestion, but nothing is
     decided for them. */
  function openChooser() {
    var el = document.getElementById('hp-region-gate');
    if (!el) return;
    el.hidden = false;
    root.classList.add('hp-region-open');
    el.addEventListener('click', function (ev) {
      var btn = ev.target.closest ? ev.target.closest('[data-region-choice]') : null;
      if (!btn) return;
      var choice = btn.getAttribute('data-region-choice');
      store(choice);
      apply(choice);
      root.classList.remove('hp-region-open');
      el.hidden = true;
      /* The collection page filters server-side too, so a choice that differs
         from the detected country needs a reload to get the right grid. */
      if (btn.getAttribute('data-needs-reload') === '1') { location.reload(); }
    });
  }

  /* The region chooser is the FIRST screen a new visitor sees (owner's call,
     2026-10-01): it must not wait behind the welcome gate. It sits at z-index
     10001 over the gate (10000), so opening it immediately simply covers the
     gate; once a region is chosen the chooser hides and the welcome gate is
     there underneath, exactly as before. (The old ordering existed because the
     chooser used to swallow the gate's Enter button; that cannot happen now,
     since the chooser is removed from the screen before the gate is clickable.) */
  function openChooserWhenReady() { openChooser(); }
  function init() {
    var region = stored();
    if (region) { apply(region); }
    else { openChooserWhenReady(); }

    /* Change it directly, from the header flags. Distinct from the
       footer link below: that one FORGETS the choice and reopens the
       chooser, which is right for "I want to think about it again" and
       wrong for "I clicked the wrong flag" — it costs a full reload and
       a modal to fix a misclick. */
    document.addEventListener('click', function (ev) {
      var b = ev.target.closest ? ev.target.closest('[data-region-set]') : null;
      if (!b) return;
      ev.preventDefault();
      var next = b.getAttribute('data-region-set');
      if (!next || next === stored()) return;
      store(next);

      /* On a product page the visitor is standing INSIDE one edition, so
         hiding links cannot move them — the page they are on is the
         wrong one. Send them to the same animal in the edition they just
         chose; every animal exists in both, so the handle always
         resolves. Everywhere else apply() is enough and nothing reloads. */
      var path = location.pathname;
      if (path.charAt(path.length - 1) === '/') { path = path.slice(0, -1); }
      var tail = path.slice(-3).toLowerCase();
      if (path.indexOf('/products/') !== -1 && (tail === '-eu' || tail === '-us')) {
        location.href = path.slice(0, -3) + '-' + next + location.search;
        return;
      }
      apply(next);
    });

    /* Let the footer/anywhere offer a way to change it later. */
    document.addEventListener('click', function (ev) {
      var t = ev.target.closest ? ev.target.closest('[data-hp-region-change]') : null;
      if (!t) return;
      ev.preventDefault();
      S.clear(KEY);
      location.reload();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }

  /* Sections that lay out asynchronously (the salon field) can insert cards
     after init; re-apply cheaply when the DOM settles. */
  var mo = new MutationObserver(function () {
    var r = stored();
    if (r) { apply(r); }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
}());
